module.exports = __webpack_public_path__ + "components/country-flag/static/na-0a53cb812898c0cacdff079bedc4a85c.svg";